export default "__VITE_PUBLIC_ASSET__be614096__"